// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const listEntriesApiAuditLogGetParamsLimitDefault = 50;
export const listEntriesApiAuditLogGetParamsCursorOneMax = 200;

export const listEntriesApiAuditLogGetParamsOrderDefault = `desc`;
export const listEntriesApiAuditLogGetParamsActorOneItemMax = 320;

export const listEntriesApiAuditLogGetParamsActorOneMax = 50;

export const listEntriesApiAuditLogGetParamsActionOneItemMax = 80;

export const listEntriesApiAuditLogGetParamsActionOneMax = 50;

export const listEntriesApiAuditLogGetParamsEventFamilyOneItemMax = 80;

export const listEntriesApiAuditLogGetParamsEventFamilyOneMax = 50;

export const listEntriesApiAuditLogGetParamsOutcomeOneItemMax = 80;

export const listEntriesApiAuditLogGetParamsOutcomeOneMax = 50;

export const listEntriesApiAuditLogGetParamsEntityTypeOneItemMax = 80;

export const listEntriesApiAuditLogGetParamsEntityTypeOneMax = 50;

export const listEntriesApiAuditLogGetParamsEntityIdOneMax = 64;

export const listEntriesApiAuditLogGetParamsSourceIpOneMax = 100;

export const listEntriesApiAuditLogGetParamsTracedDefault = false;
export const ListEntriesApiAuditLogGetParams = zod.object({
  "limit": zod.int().default(listEntriesApiAuditLogGetParamsLimitDefault),
  "cursor": zod.union([zod.string().max(listEntriesApiAuditLogGetParamsCursorOneMax),zod.null()]).optional(),
  "order": zod.enum(['asc', 'desc']).default(listEntriesApiAuditLogGetParamsOrderDefault),
  "occurred_from": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).optional(),
  "occurred_to": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).optional(),
  "actor": zod.union([zod.array(zod.string().max(listEntriesApiAuditLogGetParamsActorOneItemMax)).max(listEntriesApiAuditLogGetParamsActorOneMax),zod.null()]).optional(),
  "actor_user_id": zod.union([zod.uuid(),zod.null()]).optional(),
  "action": zod.union([zod.array(zod.string().max(listEntriesApiAuditLogGetParamsActionOneItemMax)).max(listEntriesApiAuditLogGetParamsActionOneMax),zod.null()]).optional(),
  "event_family": zod.union([zod.array(zod.string().max(listEntriesApiAuditLogGetParamsEventFamilyOneItemMax)).max(listEntriesApiAuditLogGetParamsEventFamilyOneMax),zod.null()]).optional(),
  "outcome": zod.union([zod.array(zod.string().max(listEntriesApiAuditLogGetParamsOutcomeOneItemMax)).max(listEntriesApiAuditLogGetParamsOutcomeOneMax),zod.null()]).optional(),
  "entity_type": zod.union([zod.array(zod.string().max(listEntriesApiAuditLogGetParamsEntityTypeOneItemMax)).max(listEntriesApiAuditLogGetParamsEntityTypeOneMax),zod.null()]).optional(),
  "entity_id": zod.union([zod.string().max(listEntriesApiAuditLogGetParamsEntityIdOneMax),zod.null()]).optional(),
  "source_ip": zod.union([zod.string().max(listEntriesApiAuditLogGetParamsSourceIpOneMax),zod.null()]).optional(),
  "traced": zod.boolean().default(listEntriesApiAuditLogGetParamsTracedDefault)
})

export type ListEntriesApiAuditLogGetParams = zod.input<typeof ListEntriesApiAuditLogGetParams>;
export type ListEntriesApiAuditLogGetParamsOutput = zod.output<typeof ListEntriesApiAuditLogGetParams>;
